import { useBoolean } from '@dreryk/react-common';

import { InvoiceCreateAccountModal } from './InvoiceCreateAccountModal';

type InvoiceCreateAccountModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type InvoiceCreateAccountModalOpenerProps = {
   readonly children: (renderProps: InvoiceCreateAccountModalOpenerRenderProps) => JSX.Element;
};

export const InvoiceCreateAccountModalOpener = (props: InvoiceCreateAccountModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <InvoiceCreateAccountModal onClose={closeModal} /> : null}
      </>
   );
};
